// Module
var code = "<div id=\"agentRatesGrid\"></div> <div style=\"display:none\"> <div id=\"toolBarAddition\"> <div style=\"color:#000!important;display:inline-block;padding:5px 0 0 30px\" data-bind=\"geCheckBox: includeInactive\">Include inactive </div> </div> </div>";
// Exports
export default code;